/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOval = createReactComponent("oval", "IconOval", [
  ["path", { d: "M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0", key: "svg-0" }]
]);

export { IconOval as default };
//# sourceMappingURL=IconOval.js.map
